import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface UseFetchBranchOrdersParams {
  limit?: number;
  side?: "left" | "right";
}

export const useFetchBranchOrders = (params?: UseFetchBranchOrdersParams) => {
  const { limit = 10, side = "left" } = params || {};

  const queryFn = async ({ pageParam = 1 }) => {
    const response = await fetchClient.GET("/user/me/children-orders", {
      params: {
        query: {
          page: typeof pageParam === "number" ? pageParam : 1,
          limit,
          side,
        },
      },
    });
    if (response.error) throw response.error;
    return response.data;
  };

  return useInfiniteQuery({
    queryKey: ["user", "me", "children-orders", limit, side],
    queryFn,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination;
      if (pagination?.hasNextPage) return pagination.page + 1;
      return undefined;
    },
    // refetchOnMount used to be false. Unlike a user's own purchases, a
    // child's purchase is an event nothing on this screen can invalidate --
    // there is no local mutation to hook into, so a stale-until-mount-forced
    // cache entry here meant a genuinely new child purchase could sit
    // invisible indefinitely, even across page revisits, until a hard
    // reload. Left refetchOnReconnect/refetchInterval off; only mount/focus
    // need to catch up on state that changed elsewhere.
    refetchOnReconnect: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
  });
};
